import {
  ADICIONAR_DADOS_PAGAMENTO
} from '../../actions/types'

const initialState = null;


export default function reducerDadosPagamento (state = initialState, action) {
  switch (action.type) {
    case ADICIONAR_DADOS_PAGAMENTO: {
      return action.payload
    }
    default: {
      return state
    }
  }
}
